import { Box, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../../../components/Table/Table';
import { Sort } from '../../../../models/CommonModels';
import { Device, Sim, SimUpdateRequest } from '../../../../models/UserDevicesModels';
import useDeviceDetailsSimsTable from './useDeviceDetailsSimsTable';
import Button from '../../../../components/Button/Button';

interface UseDeviceDetailsSimsTableProps {
  device: Device | null;
  sims: Sim[] | [];
  isLoading: boolean;
  isPerformingAction: boolean;
  showTotalSims?: boolean;
  updateSim: (req: SimUpdateRequest, errorCallback: () => void) => void;
  assignSim?: () => void;
}

function UseDeviceDetailsSimsTable({
  device,
  sims,
  isLoading,
  isPerformingAction,
  showTotalSims = true,
  updateSim,
  assignSim,
}: UseDeviceDetailsSimsTableProps) {
  const [t] = useTranslation();
  const [sort, setSort] = useState<Sort>({ order: 'asc', orderBy: 'status' });
  const { headers, rows, totalSims } = useDeviceDetailsSimsTable(device, sims, sort, isPerformingAction, updateSim);

  /**
   * Handle change of the table sort
   * @param s
   */
  const handleOnSort = (s: Sort) => {
    setSort(s);
  };

  return (
    <Box paddingBottom="3rem">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {showTotalSims ? (
          <Typography variant="body1" paddingBottom="1rem">
            {t('common.table.totalItems', { count: totalSims })}
          </Typography>
        ) : null}
        {assignSim ? (
          <Box sx={{ display: 'flex', marginLeft: 'auto', paddingBottom: '1rem' }}>
            <Button onClick={assignSim} label={t('pages.assignSim.title')} />
          </Box>
        ) : null}
      </Box>
      <Table
        headers={headers}
        rows={rows}
        isLoading={isLoading}
        defaultOrderBy={sort.orderBy}
        onSort={handleOnSort}
        emptyStateMessage={t('pages.userDetails.tabs.simsTable.noResults')}
      />
    </Box>
  );
}

export default memo(UseDeviceDetailsSimsTable);
